// extracted by mini-css-extract-plugin
export default {"circle":"ProgressBar_circle__Oiri-"};